// ! this has been modified to work with the new course data structure
// input is data from useFetchAllCourse
/*
    returns{
        name,
        imageUrl,
        effort,
        price,
        tags,
    }
*/
export default function courseDataParser(courseData) {
    if (!courseData) {
        return [];
    }
    
    return courseData.map(course => ({
        id: course.openedxCourseId,
        name: course.details.displayName,
        imageUrl: course.details.courseImageUrl,
        effort: course.details.effort,
        price: course.price,
        tags: course.courseTags?.map(tag => tag.tag) || [],
        startDate: course.details.start
    }))
}